import React from "react";
import "../App.css";
import piggyBank from "../assets/5243015.jpg";
import { useNavigate } from "react-router-dom"; 

function GetStartedPage() {
  const navigate = useNavigate(); 

  return (
    <div className="app">
      <main className="main-content">
        <div className="illustration">
          <img src={piggyBank} alt="Piggy Bank" className="piggy-image" />
        </div>
        <div className="text-section">
          <h1>Always take control of your finance</h1>
          <p>Finances must be arranged to set a better lifestyle in the future.</p>
        </div>
        {/* Redirect to the Finance Tracker page on click */}
        <button
          className="get-started-button"
          onClick={() => navigate("/login")}
        >
          Log In/Sign Up
        </button>
      </main>
    </div>
  );
}

export default GetStartedPage;
